'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TagRest = function () {
  function TagRest($http) {
    (0, _classCallCheck3.default)(this, TagRest);

    this.$http = $http;
    this.sprintf = require("sprintf-js").sprintf;

    this.PATH = {
      LIST: 'tags/',
      DETAIL: 'tags/%1$s/',
      LIST_RULE: 'tag-rules/',
      DETAIL_RULE: 'tag-rules/%1$s/'
    };
  }

  (0, _createClass3.default)(TagRest, [{
    key: 'create',
    value: function create(postData) {
      return this.$http.post(this.PATH.LIST, postData);
    }
  }, {
    key: 'createRule',
    value: function createRule(postData) {
      return this.$http.post(this.PATH.LIST_RULE, postData);
    }
  }, {
    key: 'createByName',
    value: function createByName(name) {
      return this.create({ name: name });
    }
  }, {
    key: 'update',
    value: function update(id, postData) {
      return this.$http.put(this.sprintf(this.PATH.DETAIL, id), postData);
    }
  }, {
    key: 'updateRule',
    value: function updateRule(id, postData) {
      return this.$http.put(this.sprintf(this.PATH.DETAIL_RULE, id), postData);
    }
  }, {
    key: 'save',
    value: function save(postData) {
      return postData.id ? this.update(postData.id, postData) : this.create(postData);
    }
  }, {
    key: 'saveRule',
    value: function saveRule(postData) {
      return postData.id ? this.updateRule(postData.id, postData) : this.createRule(postData);
    }
  }, {
    key: 'getList',
    value: function getList(query) {
      var params = null;
      if (query) {
        params = { q: query };
      }
      return this.$http.get(this.PATH.LIST, { params: params });
    }
  }, {
    key: 'getRuleList',
    value: function getRuleList(query) {
      var params = null;
      if (query) {
        params = { q: query };
      }
      return this.$http.get(this.PATH.LIST_RULE, { params: params });
    }
  }, {
    key: 'read',
    value: function read(id) {
      return this.$http.get(this.sprintf(this.PATH.DETAIL, id));
    }
  }, {
    key: 'readRule',
    value: function readRule(id) {
      return this.$http.get(this.sprintf(this.PATH.DETAIL_RULE, id));
    }
  }, {
    key: 'delete',
    value: function _delete(id) {
      return this.$http.delete(this.sprintf(this.PATH.DETAIL, id));
    }
  }, {
    key: 'deleteRule',
    value: function deleteRule(id) {
      return this.$http.delete(this.sprintf(this.PATH.DETAIL_RULE, id));
    }
  }]);
  return TagRest;
}();

exports.default = TagRest;


//////////////////
// WEBPACK FOOTER
// ./src/api/TagResource.js
// module id = 329
// module chunks = 0